import React from "react";
import { Link } from "react-router-dom";
import FixyBeeMark from "@/components/brand/FixyBeeMark";

export default function Logo({ size = 40, withWordmark = true }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
      <div className="transition-transform group-hover:rotate-[-8deg] duration-300">
        <FixyBeeMark size={size} />
      </div>
      {withWordmark && (
        <span className="font-display font-extrabold text-xl tracking-tight text-worker">
          Fixy<span className="text-hive-ink">Dany</span>
        </span>
      )}
    </Link>
  );
}
